import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.auth/reset-password/reset-password-fieldset.htm";

export class ResetPasswordFieldsetController {
  constructor() {
    basicController(this);
    let $ctrl = this;
    $ctrl.bus = $ctrl.$session.bus;
  }
}

export default {
  bindings: {
    request: "<",
    emailLabel: "@",
    emailPlaceholder: "@",
  },
  templateUrl
};
